import { connect } from '@lumapps/redux/react';
import { BaseStore } from '@lumapps/redux/types';

import {
    getLanguages,
    currentLanguageSelector as defaultLanguageSelector,
    isLanguageSelectButtonEnabled,
    inputLanguageSelector,
} from '../../ducks/selectors';
import { LanguageSelectButton } from './LanguageSelectButton';

const mapStateToProps = (state: BaseStore, props: any) => {
    const { useCustomerLanguages, defaultLanguage, isVisible = false, languages = [] } = props;

    return {
        languages: getLanguages(state, useCustomerLanguages, languages),
        defaultLanguage: defaultLanguage || defaultLanguageSelector(state),
        isVisible: isLanguageSelectButtonEnabled(state) || isVisible,
        inputLanguage: inputLanguageSelector(state),
    };
};

const ConnectedLanguageSelectButton = connect(mapStateToProps)(LanguageSelectButton);

export { ConnectedLanguageSelectButton as LanguageSelectButton };
